module.exports = __webpack_public_path__ + "static/media/E-Commerce.90866d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/E-Commerce.png
// module id = 42
// module chunks = 1